import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as MyBusinessIcon } from '../../icons/MyBusinessIcon.svg'
import { DreamStageModal, GetAIModal } from './AppModal'
import { MyBusinessSchema, BusinessFormData } from '../../data/types';
import { useAllBusinesses, useUpdateBusinessDetails } from '../../hooks/businesshooks';
import { useCompleteSignIn } from '../../hooks/authhooks'
import BusinessCard from '../../components/Desktop/BusinessCard';
import { mapBusinessFormToSchema } from '../../utils/businessProfile';
import { getAllResources } from '../../api/crud';
import { dscvryExpertPath } from '../../utils/contactBuilder';

const MyBusinessGrid = () => {
  const navigate = useNavigate();
  const { user } = useCompleteSignIn();
  const username = user?.username || user?.email || ''
  const uid = user?.uid || ''
  const [dreamModalIsOpen, setDreamModalIsOpen] = useState(false);
  const [getAIModalIsOpen, setGetAIModalIsOpen] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  const [editingBusiness, setEditingBusiness] = useState<MyBusinessSchema | null>(null);
  const { addBusinessDetails, removeBusinessDetails } = useUpdateBusinessDetails(uid);
  const { businesses, isLoadingAllBusinesses } = useAllBusinesses(uid);
  const [savedBusiness, setSavedBusiness] = useState<MyBusinessSchema | null>(null);
  const [wasUpdate, setWasUpdate] = useState(false);
  
  const handleSubmitForm = async (data: BusinessFormData) => {
    const updating = Boolean(editingBusiness?.id);
    const newBusinessData = mapBusinessFormToSchema(data, username, {
      uid,
      id: editingBusiness?.id,
    });
    const saved = await addBusinessDetails(newBusinessData, data.logoFile);
    setSavedBusiness(saved || newBusinessData);
    setWasUpdate(updating);
    
    setDreamModalIsOpen(false);
    setGetAIModalIsOpen(true);
  }

  const openContactResearch = async (business: MyBusinessSchema) => {
    const experts = await getAllResources('expert');
    navigate(dscvryExpertPath(experts || [], business.id || ''));
  };

  const handleEditBusiness = (business: MyBusinessSchema) => {
    setEditingBusiness(business);
    setDreamModalIsOpen(true);
    setShowIntro(false);
  };

  const handleDeleteBusiness = async (business: MyBusinessSchema) => {
    if (window.confirm('Are you sure you want to delete this business?') && business.id) {
      await removeBusinessDetails(business.id);
    }
  };

  // useEffect(() => {
  //   if (username) {
  //     reloadAllBusinesses()
  //   }
  // }, [username, reloadAllBusinesses])

  if (isLoadingAllBusinesses && businesses) {
    return (
      <div className="flex items-center justify-center min-h-[800px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primaryDark-400"></div>
      </div>
    );
  } else {
    return (
    <>
      {businesses && businesses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
          {businesses.map((business, index) => (
            <BusinessCard 
              key={business.id || index} 
              business={business} 
              onEdit={handleEditBusiness}
              onDelete={handleDeleteBusiness}
              onOpen={(item) => item.id && navigate(`/business/${item.id}`)}
              onContactResearch={openContactResearch}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-start min-h-[800px] p-6">
          <div className="w-[80px] h-[80px] mb-6 bg-[#EFF8FA] rounded-full p-4">
            <MyBusinessIcon className="w-full h-full text-primaryDark-400" />
          </div>
          <h2 className="text-xl font-semibold mb-2">No Business Added Yet</h2>
          <p className="text-gray-600 text-center mb-6">
            It looks like you haven't set up your business yet.<br />
            Let's help you get started and connect you to the right resources!
          </p>
          <button 
            className="bg-primaryDark-100 border-0 hover:bg-primaryDark-300 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
            onClick={() => setDreamModalIsOpen(true)}
          >
            Add My Business
          </button>
        </div>
      )}

      <DreamStageModal 
        isOpen={dreamModalIsOpen} 
        showIntro={showIntro}
        setShowIntro={setShowIntro}
        closeAppModal={() => {
          setShowIntro(true)
          setDreamModalIsOpen(false)
          setEditingBusiness(null)
        }} 
        handleSubmitForm={handleSubmitForm}
        editingBusiness={editingBusiness}
      />
      <GetAIModal 
        isOpen={getAIModalIsOpen} 
        setIsOpen={setGetAIModalIsOpen}
        setDreamModalIsOpen={setDreamModalIsOpen}
        business={savedBusiness}
        wasUpdate={wasUpdate}
      />
    </>
  )}
}

export default MyBusinessGrid

